// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"29eae1ad","239":"baf8dae2","455":"5e9445f4"}[chunkId] + ".chunk.js";
};